module.exports = __webpack_public_path__ + "static/media/tab1.ef0f027e.png";